import { Heading } from '@components'
import { type Session, api } from '@here/api'
import { useNavigate } from '@solidjs/router'
import { Auth as AuthComponent } from '@supabase/auth-ui-solid'
import { css, cx } from 'styled-system/css'
import { Flex } from 'styled-system/jsx'
import { button, formLabel, input, link } from 'styled-system/recipes'
import { setUser } from './state'

export default function SignIn() {
	const navigate = useNavigate()

	const doLogin = (session: Session) => {
		setUser(session)
		navigate('/')
	}

	api().auth.onAuthStateChange((event, session) => {
		if (session && event === 'SIGNED_IN') {
			doLogin(session)
		}
	})

	return (
		<main
			class={css({
				display: 'grid',
				alignItems: {
					base: 'center',
					mdDown: 'start',
				},
				pt: {
					mdDown: 8,
				},
				justifyContent: 'center',
				height: '100vh',
				width: '100vw',
			})}
		>
			<div
				class={css({
					maxWidth: '95vw',
					width: '600px',
					padding: 'md',
					background: 'bg.subtle',
					border: 'solid 2px',
					borderColor: 'tscGreen.10',
					p: 4,
					borderRadius: 'md',
				})}
			>
				<Flex
					justifyContent="start"
					alignContent="center"
					gap={2}
				>
					<img
						class={css({
							height: '40px',
							width: '40px',
						})}
						src={'/logo_dark.png'}
						alt="sniper circle logo"
					/>

					<Heading
						size={{
							base: 'lg',
						}}
						lineHeight="35px"
					>
						The Sniper Cricle
					</Heading>
				</Flex>
				<AuthComponent
					appearance={{
						extend: false,
						className: {
							button: button({ variant: 'subtle', size: 'lg' }),
							label: formLabel(),
							input: input(),
							anchor: cx(link()),
							container: css({
								display: 'grid',
								color: 'fg.default',
								gap: '4',
								paddingTop: '4',
							}),
							divider: css({
								borderBottom: 'solid 1px',
								borderBottomColor: 'legion.grey',
								paddingTop: '4',
							}),
						},
					}}
					redirectTo="/"
					supabaseClient={api()}
				/>
			</div>
		</main>
	)
}
